module.exports = __webpack_public_path__ + "img/final-confirm.867fddb1.svg";